export default __webpack_public_path__ + "static/media/bg-gradient-package.23a4f319.png";